import { render, staticRenderFns } from "./AppFrame.vue?vue&type=template&id=fa2a1c44&scoped=true&"
import script from "./AppFrame.vue?vue&type=script&lang=ts&"
export * from "./AppFrame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2a1c44",
  null
  
)

export default component.exports